var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("input", {
      attrs: { type: "text", readonly: "readonly", id: _vm.uniq_id },
      domProps: { value: _vm.sel_value }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }